import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'

import Mobile from './HOC/Mobile'
import Analytics from './HOC/Analytics'
import Title from './HOC/Title'
import Login from '../components/Login'

function LoginContainer({ data, location }) {
  return <Login data={data} search={qs.parse(location.search)} />
}

LoginContainer.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
}

export default Title(Analytics(Mobile(LoginContainer)), 'Login – Hi Platform')



// WEBPACK FOOTER //
// ./src/containers/Login.js